<template>
  <div class="animated fadeInRight ecommerce">

    <el-card>
      <div slot="header" class="flex justify-between">
        <span>{{ $t('auditShopCommunity.title') }}</span>
      </div>
      <el-table :data="auditShopCommunityInfo.shopCommunitys" style="width: 100%" border stripe>
        <el-table-column prop="communityId" :label="$t('auditShopCommunity.communityCode')" align="center" />
        <el-table-column prop="communityName" :label="$t('auditShopCommunity.communityName')" align="center" />
        <el-table-column prop="shopName" :label="$t('auditShopCommunity.shopName')" align="center" />
        <el-table-column prop="createTime" :label="$t('auditShopCommunity.joinTime')" align="center" />
        <el-table-column prop="startTime" :label="$t('auditShopCommunity.startTime')" align="center" />
        <el-table-column prop="endTime" :label="$t('auditShopCommunity.endTime')" align="center" />
        <el-table-column prop="stateName" :label="$t('auditShopCommunity.status')" align="center" />
        <el-table-column :label="$t('auditShopCommunity.operation')" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleAudit(scope.row)">
              {{ $t('auditShopCommunity.audit') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @current-change="handlePageChange" :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next" :total="total" style="margin-top: 20px; text-align: right" />
    </el-card>


    <audit-dialog ref="auditDialog" @auditNotify="handleAuditSubmit" />
  </div>
</template>

<script>
import { getShopCommunityList, auditShopCommunity } from '@/api/admin/auditShopCommunityApi'
import AuditDialog from '@/components/common/audit/Audit'

export default {
  name: 'AuditShopCommunity',
  components: {
    AuditDialog
  },
  data() {
    return {
      auditShopCommunityInfo: {
        shopCommunitys: [],
        conditions: {
          state: '12001'
        }
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      currentAuditInfo: null
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      try {
        const params = {
          ...this.auditShopCommunityInfo.conditions,
          page: this.currentPage,
          row: this.pageSize
        }
        const res = await getShopCommunityList(params)
        this.auditShopCommunityInfo.shopCommunitys = res.data
        this.total = res.total || 0
      } catch (error) {
        console.error('获取店铺入驻小区列表失败:', error)
      }
    },
    handleAudit(row) {
      this.currentAuditInfo = row
      this.$refs.auditDialog.open()
    },
    async handleAuditSubmit(auditData) {
      try {
        const params = {
          ...auditData,
          shopId: this.currentAuditInfo.shopId,
          storeId: this.currentAuditInfo.storeId,
          scId: this.currentAuditInfo.scId
        }
        await auditShopCommunity(params)

        this.$message.success(this.$t('common.operateSuccess'))
        this.getList()
      } catch (error) {
        this.$message.error(error)
        console.error('审核失败:', error)
      }
    },
    handlePageChange(page) {
      this.currentPage = page
      this.getList()
    }
  }
}
</script>

<style scoped>
.ecommerce {}
</style>